import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { ResourceLoginType, UserConfig } from '../../../../../models/userconfig.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'sambadb-panel',
    templateUrl: './sambadb.panel.html',
    // styleUrls: ['./sambadb.panel.css']
})
export class SambaDBPanel extends BaseDataSourcePanel {
    constructor() {
        super();
        this.DBInfoType = SambaDBInfo;
    }

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: SambaDBPanel,
            DBInfoType: SambaDBInfo
        };
    }
}

export class SambaDBInfo extends ADBInfo {
    SourcePath: string;
    LoginType: ResourceLoginType = ResourceLoginType.Anonymous;
    Username: string;
    Password: string;
    User: UserConfig;

    getTypeName(): string {
        return 'evidanza.MiddleWare.Shared.NonDatabase.SambaDBInfo';
    }
}
